export enum ArtifactFileFormats {
  DAT='DAT',
  PDF='PDF',
  XLSX='XLSX',
  ZIP='ZIP'
}
